import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export interface ApartmentStats {
  totalApartments: number;
  apartmentsWithEmail: number;
  apartmentsWithPhone: number;
  apartmentsWithOutstandingFees: number;
  apartmentsWithAppLinked?: number;
}

export interface NotificationHistory {
  id: string;
  buildingId: string;
  buildingName: string;
  content: string;
  sendTime: string;
  method: string;
  quantity: number;
  recipientCount: number;
  successCount: number;
  failureCount: number;
  billingPeriod: string;
  staffName?: string | null;
  createdAt: string;
}

class ApartmentStatsApi {
  private getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async getApartmentStats(buildingId: string): Promise<ApartmentStats> {
    const response = await axios.get(`${API_BASE_URL}/apartments/stats/${buildingId}`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async getNotificationHistory(buildingId: string): Promise<NotificationHistory[]> {
    const response = await axios.get(`${API_BASE_URL}/notification-history/building/${buildingId}`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }
}

export const apartmentStatsApi = new ApartmentStatsApi(); 